'use client';

import { Oura as OuraLogo } from '@jouzen/ecom-components/icons/Oura';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { cx } from 'class-variance-authority';
import { useMemo } from 'react';

import useAccountData from '@/app/hooks/useAccountData';
import { getLogoName } from '@/configs/partner';

import { type LogoName, Svg } from '../../ui';
import { logo as logoStyles } from './styles';

interface GlobalHeaderProps {
  readonly logo?: LogoName;
}

const GlobalHeader = ({ logo }: GlobalHeaderProps) => {
  const { orders } = useAccountData();

  const logoName = useMemo(() => {
    if (logo) return logo;
    return getLogoName(orders);
  }, [logo, orders]);

  const styles = {
    logo: logoStyles({ logo: logoName }),
  };

  return (
    <LayoutGrid className="bg-white" data-testid="global-header">
      <GridItem
        className="flex h-14 items-center lg:h-20"
        colEnd={{ sm: 'main' }}
        colStart={{ sm: 'main' }}
      >
        <span className="flex h-8 items-center gap-4 lg:h-12">
          {logoName && (
            <>
              {/* partner logo */}
              <span className={styles.logo}>
                <Svg name={logoName} />
              </span>

              {/* separator */}
              <span
                className="my-4 h-5 border-l border-solid border-gray-600 lg:h-6"
                aria-hidden="true"
              />
            </>
          )}

          <span className={cx('w-16 lg:w-20')}>
            <OuraLogo data-cy="oura-logo" />
          </span>
        </span>
      </GridItem>
    </LayoutGrid>
  );
};

export default GlobalHeader;
